export default __webpack_public_path__ + "static/smartface-de9e6d6b3bf64a91f1fcdf4fc13c8cbd.gif";